// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1VVYs","file":"styles_file__37djq"};